import { ReferralsTerm } from '@recruitee/http-types';
import { createEntityCollectionStore, getEntityCollectionActions, Scope } from '@recruitee/ngrx';

const { actions, selectors, reducer, namespace } = createEntityCollectionStore<ReferralsTerm>()(
  'ReferralsTermsCollection',
  {
    customActions: adapter => {
      const actions = getEntityCollectionActions(adapter, ({ id }) => id!);
      return {
        updateAll: (state, payload: { terms: ReferralsTerm[]; scope?: Scope }) =>
          adapter.markAsPending(state, { scope: payload.scope || null, entities: [] }),
        updateAllSuccess: actions.fetchCollectionSuccess,
        updateAllFailed: actions.fetchCollectionFailed,
      };
    },
  },
);

export {
  actions as ReferralsTermsCollectionActions,
  selectors as ReferralsTermsCollectionSelectors,
  reducer as ReferralsTermsCollectionReducer,
  namespace as ReferralsTermsCollectionNamespace,
};
